import { FaUser, FaHeart, FaShare, FaComment, FaBookmark, FaArrowRight } from 'react-icons/fa'
import './CardDemo.css'

function CardDemo() {
  return (
    <div className="card-demo">
      <section className="demo-section">
        <h4>基础卡片</h4>
        <div className="card-grid">
          <div className="card basic-card">
            <div className="card-content">
              <h5 className="card-title">基础卡片</h5>
              <p className="card-text">这是一个基础的卡片组件，可以用来展示任何内容。</p>
            </div>
          </div>

          <div className="card image-card">
            <div className="card-image">
              <div className="placeholder-image">
                <span>图片占位</span>
              </div>
            </div>
            <div className="card-content">
              <h5 className="card-title">带图片的卡片</h5>
              <p className="card-text">图片可以放在卡片顶部，增强视觉效果。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h4>社交卡片</h4>
        <div className="card-grid">
          <div className="card social-card">
            <div className="card-header">
              <div className="card-avatar">
                <FaUser />
              </div>
              <div className="card-user">
                <span className="user-name">用户名</span>
                <span className="user-time">2小时前</span>
              </div>
              <button className="card-menu">⋯</button>
            </div>
            <div className="card-content">
              <p className="card-text">
                这是一条社交动态内容，展示用户发布的信息。支持多行文本展示。
              </p>
            </div>
            <div className="card-actions">
              <button className="action-item">
                <FaHeart />
                <span>128</span>
              </button>
              <button className="action-item">
                <FaComment />
                <span>42</span>
              </button>
              <button className="action-item">
                <FaShare />
              </button>
              <button className="action-item bookmark">
                <FaBookmark />
              </button>
            </div>
          </div>

          <div className="card product-card">
            <div className="product-image">
              <div className="placeholder-image product">
                <span>产品图</span>
              </div>
              <div className="product-badge">热销</div>
            </div>
            <div className="card-content">
              <h5 className="product-name">产品名称</h5>
              <p className="product-desc">产品简短描述，说明产品的主要特点。</p>
              <div className="product-meta">
                <span className="product-price">¥99.00</span>
                <span className="product-original">¥199.00</span>
              </div>
            </div>
            <div className="card-footer">
              <button className="btn btn-primary btn-block">
                立即购买 <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h4>统计卡片</h4>
        <div className="card-grid stats-grid">
          <div className="card stat-card primary">
            <div className="stat-content">
              <div className="stat-label">总访问量</div>
              <div className="stat-value">12,589</div>
              <div className="stat-change up">+12.5%</div>
            </div>
          </div>
          <div className="card stat-card success">
            <div className="stat-content">
              <div className="stat-label">活跃用户</div>
              <div className="stat-value">3,245</div>
              <div className="stat-change up">+8.3%</div>
            </div>
          </div>
          <div className="card stat-card warning">
            <div className="stat-content">
              <div className="stat-label">待处理</div>
              <div className="stat-value">156</div>
              <div className="stat-change down">-5.2%</div>
            </div>
          </div>
          <div className="card stat-card error">
            <div className="stat-content">
              <div className="stat-label">错误率</div>
              <div className="stat-value">1.2%</div>
              <div className="stat-change up">+0.1%</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default CardDemo